import { Component } from '@lisergia/core'
import { Viewport } from '@lisergia/managers'
import { DOMRectBounds, DOMUtils, MathUtils } from '@lisergia/utilities'

import GSAP from 'gsap'
import { autorun } from 'mobx'

export default class Parallax extends Component {
  declare element: HTMLElement
  declare elements: {
    media: HTMLElement
  }

  constructor({ application, element }) {
    super({
      application,
      element,
      elements: {
        media: element.querySelector('img, video'),
      },
    })

    autorun(this.onScroll)
  }

  declare intersectionObserver: IntersectionObserver

  createIntersectionObserver() {
    this.intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.animateIn()
        } else {
          this.animateOut()
        }
      })
    })

    this.intersectionObserver.observe(this.element)
  }

  destroyIntersectionObserver() {
    this.intersectionObserver.disconnect()
  }

  declare timelineIn: GSAPTimeline

  animateIn() {
    if (this.timelineIn) {
      this.timelineIn.kill()
    }

    this.timelineIn = GSAP.timeline()

    this.timelineIn.to(this.element, {
      autoAlpha: 1,
      delay: 0.2,
      duration: 0.8,
    })
  }

  animateOut() {
    GSAP.set(this.element, {
      autoAlpha: 0,
    })
  }

  declare bounds: DOMRectBounds

  onResize() {
    this.bounds = DOMUtils.getBounds(this.element as HTMLElement, this.application!.currentPage!.scroll)
  }

  onScroll() {
    if (!this.bounds) {
      return
    }

    const scroll = this.application?.currentPage?.scroll ?? 0
    const { top, height } = this.bounds

    const scale = MathUtils.map(top - scroll, -height, Viewport.height, 1, 1.2, true)
    const translateY = MathUtils.map(top - scroll, -height, Viewport.height, 100, -100, true)

    this.elements.media.style.transform = `translate3d(0, ${translateY}px, 0) scale(${scale})`
  }

  addEventListeners() {
    Viewport.on('resize', this.onResize)
  }

  removeEventListeners() {
    Viewport.off('resize', this.onResize)
  }
}
